var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCitron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 89,
    viewBox: "0 0 76 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1474_13780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0821 4.43799H26.9175V35.1094H49.0821V4.43799Z",
    fill: "#F7EE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2316 17.0078H3.28955V83.7414H68.2316V17.0078Z",
    fill: "#F4F185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6485 5.81079H10.9033V84.1892H64.6485V5.81079Z",
    fill: "#F4F185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3668 17.0078H54.7954V33.5792H71.3668V17.0078Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1855 22.582H59.8857V40.368H71.1855V22.582Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8302 17.0078H4.6333V39.4016H15.8302V17.0078Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4557 28.2046H4.6333V44.776H10.4557V28.2046Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1583 28.2046H65.5444V83.7413H73.1583V28.2046Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.502 67.1699H60.1699V83.7414H74.502V67.1699Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.367 72.9922H54.3477V83.7412H71.367V72.9922Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5755 78.8147H48.9731V83.7413H69.5755V78.8147Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4557 66.7219H4.6333V87.3242H10.4557V66.7219Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.278 72.9922H3.28955V83.7412H16.278V72.9922Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6525 78.3667H1.49805V83.7412H21.6525V78.3667Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4403 22.3823H43.5986V28.2047H66.4403V22.3823Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9422 22.3823H17.1738V28.2047H44.9422V22.3823Z",
    fill: "#FEF1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6335 17.0063H8.73779V33.6158H21.6335V17.0063Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2238 22.3823H32.4014V28.2047H38.2238V22.3823Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52894 22.3823H-0.293457V83.7414H5.52894V22.3823Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2936 22.3823H70.4712V83.7414H76.2936V22.3823Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3669 83.2935H4.6333V89.1159H71.3669V83.2935Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2741 0.436279H48.0771V11.6332H59.2741V0.436279Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.923 2.22778H16.7261V11.1853H27.923V2.22778Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.413 5.81079H10.9033V11.1853H19.413V5.81079Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9346 10.7375H7.76855V17.0078H14.9346V10.7375Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73785 16.9656H3.18262V22.5873H8.73785V16.9656Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6487 5.81079H53.0039V11.6332H64.6487V5.81079Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6382 11.5076H63.083V17.0065H68.6382V11.5076Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2623 16.5598H66.4399V22.8301H72.2623V16.5598Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2743 0.436279H16.7261V6.70655H59.2743V0.436279Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5474 22.582H38.1968V28.035H43.5474V22.582Z",
    fill: "#FEF1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2183 44.7761H17.2744V47.5475H25.2183V44.7761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2743 47.553H14.5029V55.5405H17.2743V47.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9897 47.553H25.2183V55.5405H27.9897V47.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1596 63.1448H41.1035V60.3734H33.1596V63.1448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1061 60.3708H43.8774V55.0622H41.1061V60.3708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3907 60.3708H33.1621V55.0622H30.3907V60.3708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3167 47.4634H47.6294V57.7645H50.3167V47.4634Z",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0348 47.9114H51.2124V55.5253H57.0348V47.9114Z",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.393 47.553H55.6216V55.5405H58.393V47.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0037 52.8379H50.3164V57.7645H53.0037V52.8379Z",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7953 45.2241H48.0771V53.7338H54.7953V45.2241Z",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9535 50.2698H50.1494V52.9867H52.9535V50.2698Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6217 47.553H52.9048V50.2699H55.6217V47.553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.077 47.4634H44.9419V55.5252H48.077V47.4634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6216 44.7761H47.6777V47.5475H55.6216V44.7761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3169 57.7183H47.5962V60.4624H58.3169V57.7183Z",
    fill: "#F4A688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6912 55.0774H47.6294V57.7647H55.6912V55.0774Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2071 57.7646H14.4863V60.5088H25.2071V57.7646Z",
    fill: "#F4A688"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1474_13780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 89,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitron);
export default __webpack_public_path__ + "static/media/Citron.53a02363fcda27fc48c663dce99795bc.svg";
export { ForwardRef as ReactComponent };